(function($) {
    $(document).ready(function(){
        
        const $more = $('.more');   
        if ($more.length > 0) {

            $('.more').each(function() {
                const $more = $(this);
                $more.children().each(function() {
                    const $child = $(this);
                    $child.css('height', $child.outerHeight(true));
                });
                $more.css('height', $more.outerHeight(true));
                $more.hide();
            });

            $('.more').each((index,element) => {
                const $toggleLink = $(element).siblings('.expand-link').find('a');
                $toggleLink.on('click', function(){
                    if( !$(element).hasClass('open') ) {
                        $(element).slideDown();
                        $(element).addClass('open');
                        $(this).contents().eq(0)[0].textContent = 'See Less';
                    } else {
                        $(element).slideUp();
                        $(element).removeClass('open');
                        $(this).contents().eq(0)[0].textContent = 'See More';
                    }
                });
            });
        }

    });
})(jQuery);